import { Box, Button } from '@mui/material';
import EastIcon from '@mui/icons-material/East';

function DemandOverviewActions({ onCreate, onListView }) {
  return (
    <Box className="sas-demand-actions">
      <Button
        variant="contained"
        onClick={onCreate}>
        CREATE
      </Button>

      <Button
        onClick={onListView}
        endIcon={<EastIcon fontSize="small" />}>
        Go to List View
      </Button>
    </Box>
  );
}

export default DemandOverviewActions;
